(ns manage.product-modal.view
  (:require [common.modal.view :refer [defmodal modal-v2]]
            [manage.product-table.view :as product-table]
            [uix.core :refer [$]]))

(defmodal product-modal :product-modal
  {:max-width "lg"}
  [{:keys [on-select disabled-products]}]
  ($ modal-v2
     {:title "Products"}
     ($ product-table/products-datagrid
        {:on-row-click on-select
         :disabled-products disabled-products})))
